import { useState } from "react";
import { Calendar, Megaphone, FileText, Mail } from "lucide-react";
import { Tabs, TabPanel, type Tab } from "@/components/ui/Tabs";
import { EventsList } from "@/features/events/EventsList";
import { AnnouncementsList } from "@/features/events/AnnouncementsList";
import { FileLibrary } from "@/features/events/FileLibrary";
import { LettersList } from "@/features/events/LettersList";

const eventTabs: Tab[] = [
  { id: "events", label: "Events", icon: Calendar },
  { id: "announcements", label: "Announcements", icon: Megaphone },
  { id: "files", label: "File Library", icon: FileText },
  { id: "letters", label: "Letters", icon: Mail },
];

export function EventsPage() {
  const [activeTab, setActiveTab] = useState("events");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          Events & Resources
        </h1>
        <p className="text-sm text-muted-foreground">
          Community events, announcements, files, and letter templates.
        </p>
      </div>

      <Tabs tabs={eventTabs} activeTab={activeTab} onChange={setActiveTab} />

      <TabPanel id="events" activeTab={activeTab}>
        <EventsList />
      </TabPanel>

      <TabPanel id="announcements" activeTab={activeTab}>
        <AnnouncementsList />
      </TabPanel>

      <TabPanel id="files" activeTab={activeTab}>
        <FileLibrary />
      </TabPanel>

      <TabPanel id="letters" activeTab={activeTab}>
        <LettersList />
      </TabPanel>
    </div>
  );
}
